export default function FooterTotals({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) {
  return (
    <div style={{ marginRight: 10 }}>
      <b>{label}</b>: {value === "NaN" ? "" : value}
    </div>
  );
}
